<template>
  <div class="booking-page">
    <div class="tickets-area">
      <a class="back-link" href="">
        <span class="icon">
          <inline-svg src="/assets/svg/long-arrow-back.svg" />
        </span>
        Tillbaka till evenemanget
      </a>

      <section class="ticket-section mt-12">
        <h2>Tillgängliga biljetter</h2>
        <NewPublicEventSelectTicketsList :tickets="tickets" />
      </section>

      <section class="ticket-section">
        <h2>Lägg till ytterligare</h2>
        <NewPublicEventSelectTicketsList :tickets="tickets" />
      </section>
    </div>

    <memlist-card class="summary-card">
      <div class="summary-header">
        <img src="/assets/images/example1.png" alt="" />
        <span class="event-title">{{ item.name }}</span>
      </div>

      <div class="summary-table">
        <div class="row head">
          <span style="color: #959595;">Biljetter</span>
          <span style="color: #959595;">Kostnad</span>
          <span></span>
        </div>

        <div class="row" v-for="n in 2" :key="n">
          <span>1 x Gold</span>
          <span>105&nbsp;SEK</span>
          <memlist-table-button
            svg="/assets/svg/trash2.svg"
            class="trash"
            
            @click="delete_ticket_clicked(n)"
          />
        </div>

        <div class="row total ml-border-top py-4 ml-border-bottom">
          <span>Total</span>
          <span style="color: #35aaca;">605&nbsp;SEK</span>
          <span></span>
        </div>

        <div class="row">
          <span style="color: #959595;">Avgifter</span>
          <span></span><span></span>
        </div>
        <div class="row">
          <span>Totalt ex moms</span>
          <span>450&nbsp;SEK</span>
          <span></span>
        </div>
        <div class="row">
          <span>Moms&nbsp;25&nbsp;%</span>
          <span>150&nbsp;SEK</span>
          <span></span>
        </div>
        <div class="row total-pay">
          <span>Att betala</span>
          <span>600&nbsp;SEK</span>
          <span></span>
        </div>
      </div>

      <memlist-button variant="primary" class="pay-btn">Boka nu</memlist-button>
    </memlist-card>
  </div>
</template>


<script>
import NewPublicEventSelectTicketsList from './NewPublicEventSelectTicketsList.vue';

export default {
  name: 'NewPublicEventBookingSummaryPage',
  components: {
    NewPublicEventSelectTicketsList,
  },
  data() {
    return {
      item: {
        name: 'BBQ Party 2025',
        event_id: 1,
      },
      tickets: [
        { name: 'Biljett För medlemmar', amount: 100, currency: 'SEK', companies: ['Förening 1', 'Förening 2'], qty: 0 },
        { name: 'Biljett För alla',      amount: 200, currency: 'SEK', companies: [],                              qty: 0 },
      ],
    };
  },
  methods: {
    delete_ticket_clicked(id) {}
  },
};
</script>

<style scoped>
.booking-page{
  display:grid;
  grid-template-columns:1fr 360px;
  gap:24px;
  max-width:1100px;
  margin:0 auto;
  padding:24px 16px
}

@media(max-width:960px){
  .booking-page{
    grid-template-columns:1fr
  }
}

.back-link{
  display:inline-flex;
  align-items:center;
  gap:6px;
  font-size:1.1rem;
  color:#8e8e8e;
  text-decoration:underline;
}

.icon :deep(svg){
  width:16px;
  height:16px;
  display:block;
  fill:currentColor;
}

.ticket-section{
  margin-bottom:32px
}

.ticket-section h2{
  margin:0 0 12px;
  font-size:1.25rem;
  font-weight:600
}

.summary-card{
  padding:20px;
  background-color: #f6fdff;
}

.summary-header{
  display:flex;
  align-items:center;
  gap:12px;
  margin-bottom:20px;
}

.summary-header img{
  width:64px;
  height:64px;
  border-radius:8px;
  object-fit:cover
}

.event-title{
  font-weight:600;
  font-size:1.125rem
}

.summary-table{
  display:flex;
  flex-direction:column;
  gap:8px;
  margin-bottom:24px
}

.summary-table .row{
  display:grid;
  grid-template-columns:1fr 90px 32px;
  align-items:center;
  font-size:.95rem;
  gap:8px
}

.summary-table .head{
  border-bottom: 1px solid #e5e7eb;
  padding-bottom:4px;
}

.ml-border-bottom {
  border-bottom: 1px solid #e5e7eb;
}

.ml-border-top {
  border-top: 1px solid #e5e7eb;
}

.summary-table .total,
.summary-table .total-pay{
  font-weight:600
}

.trash{
  justify-self:end
}

.pay-btn{
  width:100%;
  display:block
}

</style>
